import { Button } from "@/components/ui/button";
import { CheckCircle2, DoorOpen } from "lucide-react";

export default function PaymentSuccessView({ paidTotal, paidChange, onCloseTable, onBack }) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-8 gap-6">
      <div className="w-24 h-24 rounded-full bg-emerald-100 flex items-center justify-center">
        <CheckCircle2 className="w-14 h-14 text-emerald-600" />
      </div>
      <div className="text-center">
        <p className="text-2xl font-black text-gray-800">Pagamento Registrado!</p>
        <p className="text-4xl font-black text-emerald-600 mt-1">€{paidTotal.toFixed(2)}</p>
        {paidChange > 0 && (
          <div className="mt-3 bg-amber-50 border border-amber-200 rounded-xl px-6 py-3">
            <p className="text-sm text-amber-600 font-medium">Troco a devolver</p>
            <p className="text-3xl font-black text-amber-600">€{paidChange.toFixed(2)}</p>
          </div>
        )}
      </div>
      <div className="w-full space-y-3 mt-4">
        <Button
          className="w-full h-16 bg-emerald-600 hover:bg-emerald-700 text-lg font-black gap-2"
          onClick={onCloseTable}
          data-testid="pos-encerrar-mesa-btn"
        >
          <DoorOpen className="w-6 h-6" />
          ENCERRAR MESA
        </Button>
        <p className="text-xs text-center text-gray-400">
          Encerra a mesa e libera para novos clientes
        </p>
        <Button
          variant="outline"
          className="w-full h-11 font-semibold border-gray-300 text-gray-600"
          onClick={onBack}
        >
          Voltar sem encerrar
        </Button>
      </div>
    </div>
  );
}
